// extracted by mini-css-extract-plugin
export var bubble = "_2v-0";
export var container = "_2v-3";
export var contrastBorder = "_2v-4";
export var greyOut = "_2v-2";
export var initialsWrapper = "_2v-1";
export var large = "_2v-9";
export var medium = "_2v-8";
export var mediumSmall = "_2v-7";
export var mediumSmallMedium = "_2v-c";
export var micro = "_2v-5";
export var small = "_2v-6";
export var tiny = "_2v-b";
export var xTiny = "_2v-a";